import React, { useState } from "react";
import * as Yup from "yup";
import { Field, Form, FormikProps, withFormik } from "formik";
import { GTM_CLASS } from "../../../lib/constant";
import { LeadFormCategoryProps } from "../LeadFormInterface";
import { Input } from "../../Input/Input";
import { Dropdown } from "../../Dropdown/Dropdown";

import styles from "./WALeadForm.module.scss";
import classNames from "classnames";

interface WAFormValues {
  category: string;
  email: string;
  fullName: string;
  insuranceType: string;
  errors: any;
  touched: any;
  setFieldValue: any;
  values: any;
}

const WALeadForm = (props: LeadFormCategoryProps & FormikProps<WAFormValues>) => {
  const {
    errors,
    touched,
    setFieldValue,
    loading,
    buttonText,
    closePopup
  } = props;

  const [typePrefill, setTypePrefill] = useState({
    value: "",
    label: "Pilih Asuransi"
  });

  const insuranceTypeOption = [
    { label: "Kesehatan", value: "health" },
    { label: "Jiwa", value: "life" },
    { label: "Mobil", value: "auto" },
  ];

  return (
    <div className={styles.whatsappLeadform}>
      <img src="/asuransi/static/images/big_discount.png" alt="Big discount" />
      <div className={styles.whatsappLeadform__head}>
        <p className={styles.whatsappLeadform__head__title}>
          Penawaran Promo Asuransi
        </p>
        <div className={styles.whatsappLeadform__head__subtitle}>
          <div>
            Dapatkan <span className="label-discount">DISKON 25%</span>
          </div>
          <div className="whatsapp-subtitle">
            Silakan isi data Anda dibawah ini untuk berbicara dengan
            spesialis kami
          </div>
        </div>
      </div>
      <Form className={styles.whatsappLeadform__form} >
        <div className={styles.whatsappLeadform__body__field}>
          <Field name="fullName" >
            {({ field }) => (
              <>
                <label aria-label="fullName" htmlFor="fullName">
                  Nama Lengkap
                </label>
                <Input
                  text
                  id="fullName"
                  name="fullName"
                  arialabelledby="fullName"
                  placeholder="Nama lengkap"
                  error={touched.fullName && errors.fullName}
                  {...field}
                />
              </>
            )}
          </Field>
        </div>
        <div className={styles.whatsappLeadform__body__field}>
          <Field name="email" >
            {({ field }) => (
              <>
                <label aria-label="email" htmlFor="email">
                  Email
                </label>
                <Input
                  email
                  name="email"
                  id="email"
                  arialabelledby="email"
                  placeholder="Email"
                  error={touched && touched.email && errors.email}
                  {...field}
                />
              </>
            )}
          </Field>
        </div>
        <div className={styles.whatsappLeadform__body__field}>
          <Field name="insuranceType" className={styles.whatsappLeadform__body__field}>
            {({ field }) => (
              <>
                <label htmlFor="insuranceType">Jenis Asuransi</label>
                <Dropdown
                  {...field}
                  name="insuranceType"
                  error={touched.insuranceType && errors.insuranceType}
                  options={insuranceTypeOption}
                  value={typePrefill}
                  callback={(type) => {
                    setFieldValue('insuranceType', type.value);
                    setTypePrefill({
                      value: type.value,
                      label: type.label
                    });
                  }}
                />
              </>
            )}
          </Field>
        </div>
        <button
          type="submit"
          className={styles.whatsappLeadform__body__submitBtn}
        >
          <span className={`iconSprites iconSprites-white-whatsapp`} />
          <span> {loading ? "Loading..." : "Lihat Pilihan Polis"}</span>
        </button>
      </Form>
      <button
        type="button"
        onClick={() => closePopup()}
        className={classNames(styles.whatsappLeadform__body__closeBtn, GTM_CLASS.WHATSAPP_CANCEL_CLICK)}
      >
        Lewati
      </button>
    </div>
  );
};

const EnhancedForm = withFormik({
  mapPropsToValues: (props: LeadFormCategoryProps) => ({
    category: "",
    fullName: "",
    insuranceType: "",
    email: "",
  }),
  validationSchema: Yup.object().shape({
    fullName: Yup.string().required("Wajib Diisi"),
    insuranceType: Yup.string().required("Wajib Diisi"),
    email: Yup.string().email().required("Wajib Diisi"),
  }),
  handleSubmit: (values, { props }: any) => props.submitHandler(values, props.category),
});

export default EnhancedForm(WALeadForm);
